import http from 'api/httpClient';

export type AccessOU = {
  ou_code: string;
  ou_name: string;
};

export type User = {
  ecode: string;
  full_name: string;
  email: string;
  mobile_no: string;
  is_active: boolean;
  role_id: number;
  role_name: string;
  reporting_manager_ecode: string | null;
  reporting_manager_name: string | null;
  division_ou_code: string | null;
  division_name: string | null;
  access_ou_codes: string[];
  access_ous: AccessOU[];
  created_at: string;
  updated_at: string;
  last_login_at: string | null;
  key_accounts: string[];
};

export type Role = {
  role_id: number;
  role_name: string;
  access_level_id: number | null;
  access_level_name: string;
};

export type RoleOUOptions = {
  access_level_id: number | null;
  items: AccessOU[];
};

export type ListUsersResponse = {
  items: User[];
  total: number;
};

export async function listUsers(params: { q?: string; limit?: number; offset?: number, division?: string, role_id?: number }): Promise<ListUsersResponse> {
  const query = new URLSearchParams();
  if (params.q) query.set('q', params.q);
  query.set('limit', String(params.limit ?? 20));
  query.set('offset', String(params.offset ?? 0));
  if (params.division) query.set('division', params.division)
  if (params.role_id) query.set('role_id', params.role_id.toString())
  const data = await http.get(`/api/v1/users?${query.toString()}`);
  const items: User[] = Array.isArray((data as any)?.items) ? (data as any).items : Array.isArray(data) ? data : [];
  const total: number = typeof (data as any)?.total === 'number' ? (data as any).total : Array.isArray(data) ? data.length : 0;
  return { items, total };
}

export type CreateUserRequest = {
  ecode: string;
  full_name: string;
  email: string;
  mobile_no: string;
  role_id: number;
  reporting_manager_ecode?: string | null;
  division_ou_code: string;
  access_ou_codes: string[];
  key_accounts?: string[];
};

export type UpdateUserRequest = {
  full_name?: string;
  email?: string;
  mobile_no?: string;
  role_id?: number;
  reporting_manager_ecode?: string | null;
  division_ou_code?: string;
  access_ou_codes?: string[];
  key_accounts?: string[];
};

export async function createUser(payload: CreateUserRequest): Promise<User> {
  return http.post('/api/v1/users', payload);
}

export async function updateUser(ecode: string, payload: UpdateUserRequest): Promise<User> {
  return http.patch(`/api/v1/users/${encodeURIComponent(ecode)}`, payload);
}

export async function listRoles(): Promise<{ items: Role[] }> {
  return http.get('/api/v1/roles');
}

export async function getRoleOUOptions(roleId: number): Promise<RoleOUOptions> {
  return http.get(`/api/v1/users/role/${roleId}/ou-options`);
}

export type UserDropdownItem = {
  ecode: string;
  full_name: string;
};

export type UsersDropdownResponse = {
  items: UserDropdownItem[];
};

export async function listUsersDropdown(): Promise<UsersDropdownResponse> {
  return http.get('/api/v1/users/dropdown');
}

export type Division = {
  ou_code: string;
  ou_name: string;
};

export type DivisionsResponse = {
  items: Division[];
};

export async function listDivisions(): Promise<DivisionsResponse> {
  return http.get('/api/v1/users/divisions');
}

export type KeyAccount = {
  cust_code: string;
  cust_name: string;
};

export type KeyAccountsResponse = {
  items: KeyAccount[];
};

export async function listKeyAccounts(search?: string): Promise<KeyAccountsResponse> {
  const query = new URLSearchParams();
  if (search) query.set('search', search);
  return http.get(`/api/v1/users/key_accounts?${query.toString()}`);
}
